import Layout from "modules/layout/dashboard"
import { Outlet, useLocation, useNavigate } from "react-router-dom"
import { Flex, Tabs } from "antd"

import { ReactComponent as AssignationIcon } from "assets/icons/person-check.svg"
import { ReactComponent as PressignationIcon } from "assets/icons/person-add.svg"
import { ReactComponent as MySubstitutionIcon } from "assets/icons/person-up.svg"
import { ReactComponent as SubstitutionRequestIcon } from "assets/icons/person-exclamantion.svg"
import styles from "./styles.module.scss"

const { Main, Header } = Layout

const AssignationsLayout = () => {
  const navigate = useNavigate()
  const tab = useLocation().pathname.split("/")[2]

  return (
    <Layout>
      <Header />
      <Tabs
        className={styles.tabs}
        activeKey={tab}
        onTabClick={(newTab) => navigate(`/assignations/${newTab}`)}
        size="small"
        items={[
          {
            key: "assignations",
            label: "",
            icon: <AssignationIcon width={30} />,
          },
          {
            key: "preassignations",
            label: "",
            icon: <PressignationIcon width={30} />,
          },
          {
            key: "my-substitutions",
            label: "",
            icon: <MySubstitutionIcon width={30} />,
          },
          {
            key: "substitution-requests",
            label: "",
            icon: <SubstitutionRequestIcon width={30} />,
          },
        ]}
      />
      <Main>
        <Flex vertical style={{ margin: "16pt", flexGrow: 1 }} gap="middle">
          <Outlet />
        </Flex>
      </Main>
    </Layout>
  )
}

export default AssignationsLayout
